import { createElement } from 'react';
import { types } from '.';
import { FilterValueWithChildren } from 'models/FilterValueWithChildren';
import { FacetFilter } from 'models/FacetFilter';

interface FacetGroupProps extends FilterValueWithChildren {
  facets: [FacetFilter];
}

export const FacetGroup = (props: FacetGroupProps) => {
  const components = props.facets.map((facet: FacetFilter) => {
    const facetWithKey = { key: facet.name, ...facet };
    return createElement(types[facet.type], facetWithKey);
  });

  return components;
};
